import React from "react";
import { injectIntl, intlShape } from "react-intl";
import { Glyphicon, Media, OverlayTrigger, Tooltip } from "react-bootstrap";
import FormattedDayOrTime from "./FormattedDayOrTime";
import { observer } from "mobx-react";

@observer
class ConversationsListItem extends React.Component {
  render() {
    const { conversation, intl } = this.props;
    let participant = conversation.anyParticipant();

    const subjectTooltip = (
      <Tooltip id={"conversation-" + conversation.id + "-subject"}>
        <strong>{conversation.name}</strong>
      </Tooltip>
    );

    return (
      <Media
        className={conversation.unread ? "unread" : ""}
        onClick={() => conversation.openConversation()}
      >
        <Media.Left>
          <div className="online-badge">
            <img
              width={50}
              height={50}
              className="img-circle"
              src={this.props.conversation.icon}
              alt="Image"
            />
            <div
              className={`cute-badge in-badge ${
                conversation.anyParticipant().online ? "on" : "off"
                }`}
            />
          </div>
        </Media.Left>

        <Media.Body>
          <div className="bold">
            <OverlayTrigger placement="top" overlay={subjectTooltip}>
              <div className="media-title">{conversation.name}</div>
            </OverlayTrigger>
          </div>
          <div className="date small text-semi-muted">
            <FormattedDayOrTime dateToRender={conversation.updatedAt} />
          </div>
          <LastConversationMessage conversation={conversation} />
        </Media.Body>
      </Media>
    );
  }
}

class LastConversationMessage extends React.Component {
  render() {
    const { conversation } = this.props;
    if (!conversation.hasLastMessage) {
      return null;
    }
    return <div className="last-message text-semi-muted">{conversation.formattedLastMessage}</div>;
  }
}

export default injectIntl(ConversationsListItem);
